import { render } from "./Trello.vue?vue&type=template&id=6552ee4e&scoped=true"
import script from "./Trello.vue?vue&type=script&lang=js"
export * from "./Trello.vue?vue&type=script&lang=js"

import "./Trello.vue?vue&type=style&index=0&id=6552ee4e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6552ee4e"]])

export default __exports__